import React from 'react';
import { Shield, CheckCircle } from 'lucide-react';
import { guarantee } from '../data/mock';

const Guarantee = () => {
  return (
    <section className="section-padding bg-gradient-to-b from-black to-gray-900 relative">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="relative">
            {/* Background Glow */}
            <div className="absolute inset-0 bg-green-500/5 rounded-3xl blur-2xl"></div>

            {/* Content */}
            <div className="relative glass-dark border-2 border-green-500/30 rounded-3xl p-8 md:p-12">
              <div className="flex flex-col md:flex-row items-center gap-8">
                {/* Left: Icon */}
                <div className="flex-shrink-0">
                  <div className="w-32 h-32 bg-green-500 rounded-full flex items-center justify-center relative">
                    <Shield className="w-16 h-16 text-white" />
                    <div className="absolute -top-2 -right-2 w-12 h-12 bg-yellow-500 rounded-full flex items-center justify-center">
                      <CheckCircle className="w-7 h-7 text-black" />
                    </div>
                  </div>
                </div>

                {/* Right: Content */}
                <div className="flex-1 text-center md:text-left">
                  <div className="inline-block bg-green-500/10 border border-green-500/30 px-4 py-1 rounded-full mb-4">
                    <span className="text-green-400 font-semibold text-sm">{guarantee.badge}</span>
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                    {guarantee.title}
                  </h3>
                  <p className="text-gray-300 text-lg mb-4">
                    {guarantee.description}
                  </p>
                  <p className="text-gray-400">
                    {guarantee.details}
                  </p>
                </div>
              </div>

              {/* Bottom Stats */}
              <div className="grid grid-cols-3 gap-4 mt-8 pt-8 border-t border-white/10">
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-400 mb-1">100%</div>
                  <div className="text-gray-400 text-sm">Devolução</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-400 mb-1">7 dias</div>
                  <div className="text-gray-400 text-sm">Após a 1ª aula</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-green-400 mb-1">Zero</div>
                  <div className="text-gray-400 text-sm">Burocracia</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Guarantee;
